import { Section, Title } from 'core/service/pdf-generation/products/common/components/general'
import BIMESSAGES from 'core/data-model/constants/bi-messages'

const MARGIN_PARAGRAPH = 10

const breakLine = () => ({ text: '', marginTop: MARGIN_PARAGRAPH })

const FORMULA_DETAILS_TITLE = 'วิธีการคำนวณตัวอย่างตารางคำนวณผลประโยชน์'
const NOTE_FORMULA_DETAILS_TITLE = 'หมายเหตุ: สำหรับตัวอย่างตารางคำนวณผลประโยชน์'

const contents = (productCode, rateYear) => {
  switch (productCode) {
    case BIMESSAGES.BI_TYPE_PRODUCT_CODE_IINVEST:
      return iInvestContent()
    case BIMESSAGES.BI_TYPE_PRODUCT_CODE_IWEALTHY:
      return iWealthyContent(rateYear)
    case BIMESSAGES.BI_TYPE_PRODUCT_CODE_RPUDR:
      return rpudrFundContents()
    default:
      return []
  }
}

const iWealthyContent = (rateYear) => [
  Title(FORMULA_DETAILS_TITLE),
  [
    '(4)  = (1) + (2) + (3)',
    [
      '(5)  = (1) x อัตราค่าธรรมเนียมในการจัดสรรเบี้ยประกันภัยหลักเพื่อความคุ้มครองรายงวด + (2) x อัตราค่าธรรมเนียมในการจัดสรรเบี้ยประกันภัยเพื่อการลงทุนรายงวด +',
      { marginLeft: 27, text: '(3) x อัตราค่าธรรมเนียมในการจัดสรรเบี้ยประกันภัยเพื่อการลงทุนเพิ่มเติมพิเศษ' },
    ],
    '(6)  = (อัตราค่าประกันภัยรายปี / 12 / 1,000) x จำนวนเงินเสี่ยงภัยสุทธิ',
    '(7)  = งวดแรกเท่ากับ [(4)-(5)] x (อัตราค่าธรรมเนียมการบริหารกรมธรรม์ / 12) และงวดถัดไปเท่ากับ [(12) ของเดือนก่อนหน้า+(4)-(5)] x (อัตราค่าธรรมเนียมการบริหารกรมธรรม์ / 12)',
    '(8)  = งวดแรกเท่ากับ [(4)-(5)-(6)-(7)] และงวดถัดไปเท่ากับ (12) ของเดือนก่อนหน้า+(4)-(5)-(6)-(7)',
    '(9)  = ((1+อัตราผลตอบแทนการลงทุน)^(1/12)-1) x (8)',
    '(10) = (8) + (9)',
    '(11) = [ค่าเฉลี่ยของ 12 เดือนย้อนหลังของมูลค่ารับซื้อคืนหน่วยลงทุน ณ วันทำการสุดท้าย x อัตราโบนัสสำหรับการถือกรมธรรม์]',
    '(12) = (10) + (11)',
    '(13) = (12) – (มูลค่าบัญชีกรมธรรม์เฉพาะเงินลงทุนในส่วนของเบี้ยประกันภัยหลักเพื่อความคุ้มครองรายงวด * อัตราค่าธรรมเนียมการถอนเงินจากกรมธรรม์)',
    '(14) = 120% * จำนวนที่มากกว่าระหว่าง (จำนวนเงินเอาประกันภัย) หรือ (12)',
  ],
  breakLine(),
  Title(NOTE_FORMULA_DETAILS_TITLE),
  {
    ul: [
      'หากผู้เอาประกันภัยชำระเบี้ยประกันภัยหลักเพื่อความคุ้มครองรายงวดครบทุกงวดตั้งแต่ปีที่ 1 ถึงปีที่ 6 โดยไม่เคยทำการลดจำนวนเบี้ยประกันภัยหลักเพื่อความคุ้มครองรายงวดและไม่มีการถอนเงินใดๆ จากกรมธรรม์ หรือการขาดอายุของกรมธรรม์ในระหว่างนั้น บริษัทจะให้เงินโบนัสสำหรับการถือกรมธรรม์ทุกสิ้นปีตั้งแต่สิ้นปีกรมธรรม์ที่ 6 เป็นต้นไป โบนัสสำหรับการถือกรมธรรม์เท่ากับ ร้อยละ 0.2 ต่อปีของมูลค่ารับซื้อคืนหน่วยลงทุน ณ วันทำการสุดท้ายของแต่ละเดือน เฉลี่ย 12 เดือนย้อนหลัง ทั้งนี้ ในช่วงตั้งแต่ปีที่ผู้เอาประกันภัยเริ่มได้รับโบนัสสำหรับการถือกรมธรรม์ หากผู้เอาประกันภัย ลดจำนวนเบี้ยประกันภัยหลักเพื่อความคุ้มครองรายงวดหรือขาดการชำระเบี้ยประกันภัยหลักเพื่อความคุ้มครองรายงวดหรือมีการถอนเงินในปีกรมธรรม์ใด บริษัทจะงดให้เงินโบนัสสำหรับการถือกรมธรรม์ เฉพาะในปีกรมธรรม์นั้นๆ',
      'ในกรณีที่ผู้เอาประกันภัยต้องการเวนคืนกรมธรรม์ หรือถอนเงินจากกรมธรรม์ กรมธรรม์จะต้องถูกหักค่าธรรมเนียมในการถอนเงินจากกรมธรรม์ (Surrender Charge) ในส่วนของเบี้ยประกันภัยหลัก เพื่อความคุ้มครองรายงวด',
      [
        'จำนวนเงินเสี่ยงภัยสุทธิ หมายถึง ค่าที่มากกว่าระหว่าง 1) หรือ 2)',
        {
          marginLeft: 10,
          separator: ')',
          ol: [
            'ร้อยละ 120 ของจำนวนเงินเอาประกันภัย หักด้วยมูลค่ารับซื้อคืนหน่วยลงทุน',
            'ร้อยละ 20 ของมูลค่ารับซื้อคืนหน่วยลงทุน',
          ],
        },
      ],
      'อัตรามรณะ มาจาก อัตรามรณะตามตารางมรณะไทย ' +
        rateYear +
        ' ประเภทสามัญ และอาจเปลี่ยนแปลงได้ตามที่นายทะเบียนประกาศกำหนด',
      'ค่าการประกันภัยอาจเพิ่มขึ้นเนื่องจากสุขภาพของผู้เอาประกันภัย',
    ],
  },
]

const iInvestContent = () => [
  Title(FORMULA_DETAILS_TITLE),
  [
    '(3) = (1) + (2)',
    '(4) = (1) x อัตราค่าธรรมเนียมในการจัดสรรเบี้ยประกันภัย',
    '(5) = (2) x อัตราค่าธรรมเนียมในการจัดสรรเบี้ยประกันภัยเพิ่มเติมพิเศษ',
    '(6) = (อัตราค่าประกันภัยรายปี / 12 / 1,000) x จำนวนเงินเสี่ยงภัยสุทธิ',
    '(7) = งวดแรกเท่ากับ [(3) - (4) - (5) - (6)] x (อัตราค่าธรรมเนียมการบริหารกรมธรรม์ / 12) และงวดถัดไปเท่ากับ [(12) + (3) - (5) - (6)] x (อัตราค่าธรรมเนียมการบริหารกรมธรรม์ / 12)',
    '(8) = งวดแรกเท่ากับ [(3) - (4) - (5) - (6) - (7)] และงวดถัดไปเท่ากับ (12) ของเดือนก่อนหน้า บวก (2) หัก (5), (6) และ (7)',
    '(9) = ((1 + อัตราผลตอบแทนการลงทุน) ^ (1 / 12) - 1) x (8)',
    '(10) = (8) + (9)',
    '(11) = [ค่าเฉลี่ยของ 12 เดือนย้อนหลังของมูลค่าบัญชีกรมธรรม์ ณ วันทำการสุดท้าย x อัตราโบนัสสำหรับการถือกรมธรรม์] หากถือกรมธรรม์ครบตั้งแต่ 5 ปีขึ้นไป และไม่มีการถอนเงินใดๆ ระหว่างนั้น',
    '(12) = (10) + (11)',
    '(13) = (12) – [(12) * อัตราค่าธรรมเนียมการถอนเงินจากกรมธรรม์]',
    '(14) = อัตราร้อยละ 110 ของจำนวนเบี้ยประกันภัยชำระครั้งเดียว หลังหักจำนวนเงินทั้งหมดที่ถอนออกจากกรมธรรม์ (ถ้ามี) หรืออัตราร้อยละ 110 ของมูลค่าบัญชีกรมธรรม์ แล้วแต่จำนวนใดที่มากกว่า',
  ],
  breakLine(),
  Title(NOTE_FORMULA_DETAILS_TITLE),
  {
    marginBottom: 4,
    ul: [
      'หากผู้เอาประกันภัยถือกรมธรรม์เป็นระยะเวลา 5 ปี เป็นต้นไปและไม่มีการถอนเงินใดๆ จากกรมธรรม์ ระหว่างนั้น นับตั้งแต่วันที่กรมธรรม์มีผลบังคับ บริษัทจะให้เงินโบนัสสำหรับการถือกรมธรรม์ทุกสิ้นปี ตั้งแต่สิ้นปีกรมธรรม์ที่ 5 เป็นต้นไป เท่ากับอัตราตามตารางต่อไปนี้ของมูลค่าบัญชีกรมธรรม์เฉลี่ย 12 เดือนย้อนหลัง ของ ณ วันทำการสุดท้ายของแต่ละเดือน',
    ],
  },
  {
    marginLeft: 45,
    marginBottom: 4,
    table: {
      width: ['15%', '15%'],
      body: [
        [{ text: 'สิ้นปีกรมธรรม์ที่' }, { text: 'ร้อยละของมูลค่าบัญชีกรมธรรม์เฉลี่ย 12 เดือนย้อนหลัง' }],
        [
          { text: '5-10', alignment: 'center' },
          { text: '0.25', alignment: 'center' },
        ],
        [
          { text: '11 ขึ้นไป', alignment: 'center' },
          { text: '0.50', alignment: 'center' },
        ],
      ],
    },
  },
  {
    marginLeft: 10,
    marginBottom: 4,
    text:
      'ทั้งนี้ ในช่วงตั้งแต่ปีที่ผู้เอาประกันภัยเริ่มได้รับโบนัสสำหรับการถือกรมธรรม์ หากผู้เอาประกันภัยมีการถอนเงินในปีกรมธรรม์ใด บริษัทจะงดให้เงินโบนัสสำหรับการถือกรมธรรม์สำหรับปีกรมธรรม์นั้นๆ',
  },
  {
    ul: ['จำนวนเงินเสี่ยงภัยสุทธิ หมายถึง ค่าที่มากกว่าระหว่าง 1) หรือ 2)'],
  },
  {
    marginLeft: 10,
    marginBottom: 4,
    separator: ')',
    ol: [
      'ร้อยละ 110 ของเบี้ยประกันภัยชำระครั้งเดียว (Single Premium) หลังหักจำนวนเงินทั้งหมดที่ถอนออกจากกรมธรรม์ (Partial Withdrawal) (ถ้ามี) แล้วหักด้วยมูลค่าบัญชีกรมธรรม์ (Account Value)',
      'ร้อยละ 10 ของมูลค่าบัญชีกรมธรรม์ (Account Value)',
    ],
  },
  {
    ul: [
      'อัตรามรณะ มาจาก อัตรามรณะตามตารางมรณะไทย 2560 ประเภทสามัญ และอาจเปลี่ยนแปลงได้ตามที่นายทะเบียนประกาศกำหนด',
      'ค่าการประกันภัยอาจเพิ่มขึ้นเนื่องจากสุขภาพของผู้เอาประกันภัย',
      'ในกรณีที่ผู้เอาประกันภัยต้องการเวนคืนกรมธรรม์ หรือต้องการถอนเงินจากกรมธรรม์ กรมธรรม์จะต้องถูกหักค่าธรรมเนียมในการถอนเงินจากกรมธรรม์ (Surrender Charge)',
    ],
  },
]

const rpudrFundContents = () => [
  Title(FORMULA_DETAILS_TITLE),
  [
    '(3) = (1) + (2) ',
    '(4) = (1) x อัตราค่าธรรมเนียมในการจัดสรรเบี้ยประกันภัยหลักเพื่อความคุ้มครอง',
    '(5) = (2) x อัตราค่าธรรมเนียมในการจัดสรรเบี้ยประกันภัยเพื่อการลงทุนเพิ่มเติมพิเศษ',
    '(6) = อัตราค่าการประกันภัยรายเดือน x จำนวนเงินเสี่ยงภัยสุทธิ',
    '(7) = ค่าการประกันภัยรายเดือนสำหรับสัญญาเพิ่มเติมแบบชำระค่าการประกันภัยโดยการขายคืนหน่วยลงทุนที่ผู้เอาประกันภัยเลือกซื้อ',
    '(8) = (6) + (7)',
    [
      '(9) สำหรับในปีกรมธรรม์ที่ 1 เดือนที่ 1= [[(1) – (4)] x อัตราค่าธรรมเนียมการบริหารกรมธรรม์ต่อเดือน] + [[(2) – (5)] x อัตราค่าธรรมเนียมการบริหารกรมธรรม์ต่อเดือน] และ',
      '(9) สำหรับในเดือนต่อๆไป = [[(10) ของเดือนก่อนหน้า + (1) - (4)] x อัตราค่าธรรมเนียมการบริหารกรมธรรม์ต่อเดือน] + [[(11) ของเดือนก่อนหน้า + (2) - (5)] x ',
      'อัตราค่าธรรมเนียมการบริหารกรมธรรม์ต่อเดือน]',
    ],
    '(10) = (10.3)+(10.4)+(11.4)',
    '(11) = (11.3)',
    [
      '(10.1) สำหรับในปีกรมธรรม์ที่ 1 เดือนที่ 1 = (1) - (4) - (8) - (9) และ',
      '(10.1) สำหรับในเดือนต่อ ๆ ไป = (10) ของเดือนก่อนหน้า + (1) - (4) - (8) - (9)',
    ],
    [
      '(11.1) สำหรับในปีกรมธรรม์ที่ 1 เดือนที่ 1 = (2) - (5) และ',
      '(11.1) สำหรับในเดือนต่อ ๆ ไป = (11) ของเดือนก่อนหน้า + (2) - (5)',
    ],
    {
      columns: [
        {
          text: '(10.2) = [(1 + อัตราผลตอบแทนในส่วนของการลงทุนต่อปี)',
          width: 'auto',
        },
        {
          text: '(1/12)',
          fontSize: 8,
          width: 18,
        },
        {
          text: ' -1] x (10.1)',
          width: 'auto',
        },
      ],
    },
    {
      columns: [
        {
          text: '(11.2) = [(1 + อัตราผลตอบแทนในส่วนของการลงทุนต่อปี)',
          width: 'auto',
        },
        {
          text: '(1/12)',
          fontSize: 8,
          width: 18,
        },
        {
          text: ' -1] x (11.1)',
          width: 'auto',
        },
      ],
    },
    '(10.3) = (10.1) + (10.2)',
    '(11.3) = (11.1) + (11.2)',
    '(10.4) = [(10.3) ณ วันทำการสุดท้ายของแต่ละเดือนตามปีปฏิทิน 12 เดือนย้อนหลัง / 12] x อัตราโบนัสสำหรับการชำระเบี้ยประกันภัยหลักเพื่อความคุ้มครอง',
    '(11.4) = [(11.3) ณ วันทำการสุดท้ายของแต่ละเดือนตามปีปฏิทิน 12 เดือนย้อนหลัง / 12] x อัตราโบนัสสำหรับการชำระเบี้ยประกันภัยหลักเพื่อความคุ้มครอง',
    '(12) = (10) - [(10) x อัตราค่าธรรมเนียมในการถอนเงินจากกรมธรรม์จากหน่วยลงทุนของเบี้ยประกันภัยหลักเพื่อความคุ้มครอง]',
    '(13) = (11)',
    '(14) = 1.05 x (10) + (11) + จำนวนเงินเอาประกันภัย',
  ],
]

const rpudrNoteFundContents = () => [
  Title(NOTE_FORMULA_DETAILS_TITLE),
  [
    '1. มูลค่าที่แสดงไว้ในเอกสารนี้เป็นเพียงตัวอย่างมูลค่าประมาณการ จัดทำขึ้นภายใต้สมมติฐาน ดังต่อไปนี้',
    {
      marginLeft: 15,
      text:
        '1.1. อัตราผลตอบแทนในส่วนของการลงทุนต่อปีที่ได้แสดงไว้เป็นอัตราผลตอบแทนที่ไม่รับรอง โดยกำหนดขึ้นเพื่อแสดงความเข้าใจเท่านั้น มิได้เป็นการแสดงผลตอบแทนจริงที่ได้รับจากกรมธรรม์',
    },
    {
      marginLeft: 15,
      text:
        '1.2. กำหนดให้ราคาขายหน่วยลงทุน เท่ากับราคารับซื้อคืนหน่วยลงทุน ซึ่งราคาดังกล่าวอาจเพิ่มขึ้นหรือลดลงตามผลประกอบการของกองทุน',
    },
    {
      marginLeft: 15,
      text: '1.3. เบี้ยประกันภัยได้รับชำระตามตารางข้างต้น ณ วันครบกำหนดชำระเบี้ยประกันภัย',
    },
    {
      marginLeft: 15,
      text: '1.4. ไม่มีการหยุดพักชำระเบี้ยประกันภัยเกิดขึ้น',
    },
    {
      marginLeft: 15,
      text: '1.5. ไม่มีการถอนเงินจากกรมธรรม์',
    },
    {
      marginLeft: 15,
      text: '1.6. ใช้หลักการปัดเศษทศนิยมตามหลักสากล',
    },
    '2. มูลค่าที่แสดงข้างต้นเป็นเพียงตัวอย่างการคำนวณตามสมมติฐานที่ว่าไม่มีการเปลี่ยนแปลงอัตราค่าธรรมเนียมกรมธรรม์ และค่าการประกันภัยเป็นมูลค่าที่ได้รวมค่าการประกันภัยเพิ่มสำหรับ',
    {
      marginLeft: 11,
      text: 'ภัยต่ำกว่ามาตรฐาน เนื่องจากสุขภาพและ/หรืออาชีพ ไว้แล้ว (ถ้ามี)',
    },
    {
      marginLeft: 11,
      text:
        'ทั้งนี้ค่าธรรมเนียมกรมธรรม์สามารถเปลี่ยนแปลงได้ตามที่บริษัทกำหนด โดยรายละเอียดค่าธรรมเนียมกรมธรรม์ได้แสดงไว้ในตารางค่าธรรมเนียมกรมธรรม์ของเอกสารประกอบการเสนอขาย',
    },
    {
      marginLeft: 11,
      text: 'กรมธรรม์ประกันชีวิตควบการลงทุน',
    },

    '3. เอกสารนี้จัดทำขึ้นเพื่อเสริมสร้างความเข้าใจในกรมธรรม์ประกันชีวิตควบการลงทุน แบบ ไอลิงค์ (ยูนิตลิงค์) เท่านั้น โดยจะแสดงให้เห็นถึงผลกระทบของมูลค่ารับซื้อคืนหน่วยลงทุนที่เกิดจากการ',
    {
      marginLeft: 11,
      text:
        'จ่ายค่าธรรมเนียมกรมธรรม์ต่าง ๆ รวมถึงผลตอบแทนการลงทุน ทั้งนี้ สมมติฐานเหล่านี้จะไม่มีส่วนเกี่ยวข้องกับเงื่อนไขต่าง ๆ ที่ถูกระบุไว้ในกรมธรรม์',
    },
    '4. สงวนลิขสิทธิ์ตามกฎหมาย ห้ามทำซ้ำ ดัดแปลง ไม่ว่าส่วนหนึ่งส่วนใดของเอกสารนี้ เว้นแต่จะได้รับอนุญาตจากบริษัท',
    '5. สัญญาเพิ่มเติมแบบชำระค่าการประกันภัยโดยการขายคืนหน่วยลงทุน หมายถึง สัญญาเพิ่มเติมที่แนบอยู่กับกรมธรรม์ ซึ่งมีการชำระค่าการประกันภัยโดยการขายคืนหน่วยลงทุนของกองทุนภายใต้กรมธรรม์',
    {
      marginLeft: 11,
      text:
        'โดยอัตโนมัติเป็นรายเดือน โดยอัตราค่าการประกันภัยสำหรับสัญญาเพิ่มเติมแบบชำระค่าการประกันภัยโดยการขายคืนหน่วยลงทุนจะอ้างอิงตามตารางอัตราค่าการประกันภัยสำหรับสัญญาเพิ่มเติมนั้น',
    },
    {
      marginLeft: 11,
      text:
        'ทั้งนี้ บริษัทสงวนสิทธิในการปรับค่าการประกันภัยในรอบปีกรมธรรม์อันเนื่องมาจากปัจจัยต่างๆ เช่น อายุ ขั้นอาชีพ ประสบการณ์การจ่ายค่าสินไหมทดแทนของบริษัท เป็นต้้น สำหรับสัญญาเพิ่มเติมกลุ่ม',
    },
    {
      marginLeft: 11,
      text:
        'ค่ารักษาพยาบาลอาจมีปัจจัยอื่น ๆ เพิ่มเติม เช่น อัตราเงินเฟ้อทางการแพทย์และค่ารักษาพยาบาล ดังที่แสดงในตัวอย่างตารางคำนวณผลประโยชน์ ซึ่งมีวัตถุประสงค์เพื่อเป็นการแสดงตัวอย่างเท่านั้น',
    },
    {
      marginLeft: 11,
      text:
        'โดยอาจมีค่าที่แตกต่างจากอัตราเงินเฟ้อทางการแพทย์และค่ารักษาพยาบาลที่แท้จริงได้ ซึ่งตัวเลขที่แสดงในตัวอย่างตารางคำนวณผลประโยชน์ได้รวมปัจจัยเรื่องอายุที่เพิ่มขึ้นและอัตราเงินเฟ้อ',
    },
    {
      marginLeft: 11,
      text:
        'ทางการแพทย์และค่ารักษาพยาบาลเท่านั้น หากมีการเพิ่มขึ้นของอัตราค่าการประกันภัยอันเนื่องมาจากปัจจัยอื่น มูลค่ารับซื้อคืนหน่วยลงทุนอาจลดลงเร็วกว่าที่ประมาณการ ส่งผลให้กรมธรรม์',
    },
    {
      marginLeft: 11,
      text:
        'สิ้นผลบังคับเร็วกว่าที่แสดงไว้ ดังนั้นในการกำหนดจำนวนเบี้ยประกันภัยที่ต้องการชำระ ผู้เอาประกันภัยจึงควรพิจารณาถึงปัจจัยอื่น ๆ ที่จะเพิ่มสูงขึ้นในอนาคต ซึ่งอาจส่งผลกระทบต่อความยั่งยืน',
    },
    {
      marginLeft: 11,
      text:
        'ของกรมธรรม์ ทั้งนี้ การปรับปรุงอัตราค่าการประกันภัยสำหรับสัญญาเพิ่มเติมแบบชำระค่าการประกันภัยโดยการขายคืนหน่วยลงทุนต้องได้รับความเห็นชอบจากนายทะเบียนก่อน',
    },
    '6. การซื้อสัญญาเพิ่มเติมแบบชำระค่าการประกันภัยโดยการขายคืนหน่วยลงทุน เหมาะสำหรับผู้ต้องการวางแผนการซื้อความคุ้มครองและมีความสามารถในการชำระเบี้ยประกันภัยระยะยาว',
    {
      marginLeft: 11,
      text:
        'โดยนำเบี้ยประกันภัยบางส่วนไปลงทุนและอาจให้ประโยชน์สูงสุดแก่ผู้เอาประกันภัย การถือสัญญาประกันภัยในระยะสั้นอาจทำให้ผู้เอาประกันภัยไม่ได้รับประโยชน์จากสัญญาประกันภัยอย่างคุ้มค่า',
    },
  ],
]

export const FormulaDetails = (productCode, rateYear) => Section('', contents(productCode, rateYear))

export const NoteFormulaRpudrDetail = () => Section('', rpudrNoteFundContents())
